(function () {
    'use strict';

    /**
     * 
     * @ngdoc service
     * @name adminCommanderDiscretion.service:CrewBatchService
     *
     * @description
     *
     */
    angular
        .module('adminCommanderDiscretion')
        .service('AdminCommanderDiscretionService', AdminCommanderDiscretionService);

    function AdminCommanderDiscretionService(AdminCommanderDiscretionFactory, RemoteService) {
        var self = this;

        var model={
        	searchRequest: AdminCommanderDiscretionFactory.getCmdDescretionSearchRequest(),
        };
        
        var statusList = [
              {title:'APPROVED', value: 'APPROVED'},
              {title:'PENDING APPROVAL', value: 'PENDING_APPROVAL'},
              {title:'REJECTED', value: 'REJECTED'},
              {title:'MISSING', value: 'MISSING'}
        ];
        
        var emailSentStatus = [
              {title:'SENT', value: 'Y'},
              {title:'PENDING', value: 'N'},               
        ];

	    self.getCmndDescretionDetailSearchrequest = function (data, successFn, errorFn) {
	         var postdata = AdminCommanderDiscretionFactory.getCmndDescretionDetailSearchrequest(data);
	         RemoteService.getCmdDescretionsDetails(postdata).then(
	        		function (response) {
	                    successFn(response);
	                },
	                function (error) {
	                    errorFn(error.msg[0]);
	                }
	         );
	    };
        
        self.searchStatusOptions = function(){
        	return statusList;
        };
        
        self.searchEmailSentStatus = function(){
        	return emailSentStatus;
        };
        
	    self.setCrewBatchSearchCriteria = function (data) {
	      var searchRequest = AdminCommanderDiscretionFactory.getCmdDescretionSearchRequest();
	      searchRequest.startPosition = data.startPosition;
	      searchRequest.pageSize = data.pageSize;
	      
	      searchRequest.cdr = data.cdr;
	      searchRequest.sector = data.sector;
	      searchRequest.submitedBy = data.submitedBy;
	      searchRequest.approvedBy = data.approvedBy;
	      
	      searchRequest.dateOccurred = data.dateOccurred;
	      searchRequest.dateGCAASubmitted = data.dateGCAASubmitted;
	      searchRequest.emailStatus = ( data.emailStatus == null ? null : data.emailStatus.value );
	      
	      searchRequest.status = ( data.status == null ? null : data.status.value );
	      
	      model.searchRequest = searchRequest;
	  };
        
	  self.getCmdDescretions = function(successFn, errorFn) {
	    RemoteService.getCmdDescretions(model.searchRequest).then(
	        function (response) {
	            if(response.success && !!response.descretionList) {
	            	var descretionList = AdminCommanderDiscretionFactory.formattedCmdDescretionCollection(response.descretionList);
	                successFn(descretionList,response.startPosition);
	            }
	        },
	        function (error) {
	            errorFn(error.msg[0]);
	        }
	    );
	  };
	  
	  self.saveAdminRemark = function(data,successFn, errorFn) {
		  var remark = {"remark":data.remarks,"id":data.generalData.cmdDescretionId};
		  RemoteService.saveAdminComanderDiscretion(remark).then(
		        function (response) {
		            if(response.success ) {
		                successFn(response);
		            }
		        },
		        function (error) {
		            errorFn(error.msg[0]);
		        }
		    );
		};
		
		
		self.changeStatus = function(status,data,successFn, errorFn) {
			  var remark = {"status":status,"id":data.generalData.cmdDescretionId};
			  RemoteService.changeAdminComanderDiscretionStatus(remark).then(
			        function (response) {
			            if(response.success ) {
			                successFn(response);
			            }
			        },
			        function (error) {
			            errorFn(error.msg[0]);
			        }
			    );
		};

    }
})();